import React, { useEffect, useState } from "react";
import "../../styles/transaction.css";
import "../../styles/common.css";
import manage_nominees from "../../images/my_profile/manage_nominees.svg";

const PersonelDetail = ({ data }) => {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header profile_header" id="headingTwo">
        <button
          className="accordion-button collapsed px-lg-4 px-md-4 px-3"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseEight"
          aria-expanded="false"
          aria-controls="collapseEight"
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <img
                src={manage_nominees}
                alt=""
                className="personel_details_img"
              />

              <span className="personal_inner_text">Nominees</span>
            </div>
          </div>
        </button>
      </h2>

      <div
        id="collapseEight"
        className="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordionExample"
      >
        <hr className="m-0" />

        <div className="accordion-body accordion-body1 profile_accordion_body">
          <div className="d-flex justify-content-end align-items-right"></div>

          <div className="card redeam_bottom_card">
            <div className="row form_body justify-content-center">
              <div className="col-xl-6 col-lg-10 col-md-10 ">
                <form>
                  {data?.nominee_1_name?.trim() && (
                    <>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        {/* <div className="col-6 my-md-2 my-1"> */}
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            <strong>1st Nominee:</strong>
                          </label>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Name:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_name?.trim() || "NA"}
                            {/* {userGetProfile?.data?.user?.name} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Relation:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_relationship?.trim() || "NA"}
                            {/* {userGetProfile?.data?.user?.dob &&
                          convertDateToDDMMYYYYStartWithYear(
                            userGetProfile?.data?.user?.dob
                          )} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Date of Birth:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span className="white-space-nowrap">
                            {data?.nominee_1_dob
                              ? new Date(
                                  data?.nominee_1_dob
                                ).toLocaleDateString("en-GB")
                              : "NA"}
                            {/* {userGetProfile?.data?.user?.email} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee %</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_applicable
                              ? Math.round(data.nominee_1_applicable)
                              : "NA"}
                            {/* {data?.nominee1_percent || "NA"} */}
                            {/* {relationLabel(
                          userGetProfile?.data?.user?.profile
                            ?.email_relation
                        )} */}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pan:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_identity_number?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Email:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_1_email?.trim() || "NA"}</span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Mobile:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_1_mobile?.trim() || "NA"}</span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pincode:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_1_pin?.trim() || "NA"}</span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee City:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_1_city?.trim() || "NA"}</span>
                        </div>
                      </div>
                      {/* <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-6 my-md-2 my-1">
                      <label className="form-label">Nominee State:</label>
                    </div>
                    <div className="col-6 my-md-2 my-1">
                      <span>{data?.nominee1_state?.trim() || "NA"}</span>
                    </div>
                  </div> */}
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Country:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_1_country?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Name:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_guardian?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Pan:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_1_guardian_pan?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      {/* <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-6 my-md-2 my-1">
                      <label className="form-label">
                        Nominee Guardian Relation:
                      </label>
                    </div>
                    <div className="col-6 my-md-2 my-1">
                      <span>{data?.nom1_guardian_relation?.trim() || "NA"}</span>
                    </div>
                  </div> */}
                    </>
                  )}

                  {data?.nominee_2_name?.trim() && (
                    <>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            <strong>2nd Nominee:</strong>
                          </label>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Name:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_2_name?.trim() || "NA"}

                            {/* {userGetProfile?.data?.user?.name} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Relation:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_2_relationship?.trim() || "NA"}
                            {/* {userGetProfile?.data?.user?.dob &&
                          convertDateToDDMMYYYYStartWithYear(
                            userGetProfile?.data?.user?.dob
                          )} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Date of Birth:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span className="white-space-nowrap">
                            {data?.nominee_2_dob
                              ? new Date(
                                  data?.nominee_2_dob
                                ).toLocaleDateString("en-GB")
                              : "NA"}
                            {/* {userGetProfile?.data?.user?.email} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee %</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {/* {data?.nominee2_percent || "NA"} */}
                            {data?.nominee_2_applicable
                              ? Math.round(data.nominee_2_applicable)
                              : "NA"}
                            {/* {relationLabel(
                          userGetProfile?.data?.user?.profile
                            ?.email_relation
                        )} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pan:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_2_identity_number?.trim() || "NA"}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Email:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_2_email?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Mobile:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_2_mobile?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pincode:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_2_pin?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee City:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_2_city?.trim() || "NA"}</span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                      <label className="form-label">Nominee State:</label>
                    </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nom2_state?.trim() || "NA"}</span>
                        </div>
                      </div> */}
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Country:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_2_country?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Name:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_2_guardian?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Pan:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_2_guardian_pan?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      {/* <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-6 my-md-2 my-1">
                      <label className="form-label">
                        Nominee Guardian Relation:
                      </label>
                    </div>
                    <div className="col-6 my-md-2 my-1">
                      <span>{data?.nom2_guardian_relation?.trim() || "NA"}</span>
                    </div>
                  </div> */}
                    </>
                  )}

                  {data?.nominee_3_name?.trim() && (
                    <>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            <strong>3rd Nominee:</strong>
                          </label>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Name:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_name?.trim() || "NA"}
                            {/* {userGetProfile?.data?.user?.name} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Relation:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_relationship?.trim() || "NA"}
                            {/* {userGetProfile?.data?.user?.dob &&
                          convertDateToDDMMYYYYStartWithYear(
                            userGetProfile?.data?.user?.dob
                          )} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Date of Birth:
                          </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span className="white-space-nowrap">
                            {data?.nominee_3_dob
                              ? new Date(
                                  data?.nominee_3_dob
                                ).toLocaleDateString("en-GB")
                              : "NA"}
                            {/* {userGetProfile?.data?.user?.email} */}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee %</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_applicable
                              ? Math.round(data.nominee_3_applicable)
                              : "NA"}
                            {/* {data?.nominee3_percent || "NA"} */}
                            {/* {relationLabel(
                          userGetProfile?.data?.user?.profile
                            ?.email_relation
                        )} */}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pan:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_identity_number?.trim() || "NA"}
                          </span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Email:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_1_email?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Mobile:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_1_mobile?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Pincode:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_1_pin?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee City:</label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                          <span>{data?.nominee_3_city?.trim() || "NA"}</span>
                        </div>
                      </div>

                      {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3 personalAccordian">
                    <div className="col-6 my-md-2 my-1">
                      <label className="form-label">Nominee State:</label>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-7 my-md-2 my-1">
                      <span>{data?.nom3_state?.trim() || "NA"}</span>
                    </div>
                  </div> */}

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">Nominee Country:</label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>{data?.nominee_3_country?.trim() || "NA"}</span>
                        </div>
                      </div>

                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Name:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_guardian?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                        <div className="col-6 my-md-2 my-1">
                          <label className="form-label">
                            Nominee Guardian Pan:
                          </label>
                        </div>
                        <div className="col-6 my-md-2 my-1">
                          <span>
                            {data?.nominee_3_guardian_pan?.trim() || "NA"}
                          </span>
                        </div>
                      </div>
                      {/* <div className="row align-items-center personalAccordian  mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-6 my-md-2 my-1">
                      <label className="form-label">
                        Nominee Guardian Relation:
                      </label>
                    </div>
                    <div className="col-6 my-md-2 my-1">
                      <span>{data?.nom3_guardian_relation?.trim() || "NA"}</span>
                    </div>
                  </div> */}
                    </>
                  )}

                  {(!data?.nominee_1_name?.trim() && !data?.nominee_2_name?.trim() && !data?.nominee_3_name?.trim()) && (
                    <>
                    No nominee found
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonelDetail;
